import styled from 'styled-components';
import { spacing, borderRadius } from '@naf/theme';
import { nafColor } from '@nafcore/theme';
import { Text } from '@naf/text';
import { Info } from '@styled-icons/material-outlined/Info';
import { NotificationType } from './Notification';
import { propValidationConfig } from './propValidationConfig';
export const Container = styled.div.withConfig(propValidationConfig).withConfig({
  displayName: "Styles__Container",
  componentId: "sc-92xbps-0"
})(["display:flex;flex-direction:row;flex-wrap:wrap;border-radius:", ";padding:18px 22px;", ""], borderRadius.L, ({
  variant
}) => {
  switch (variant) {
    case NotificationType.ACTION:
      return `
            background-color: ${nafColor.signature.yellow20};
            `;
    case NotificationType.ERROR:
      return `
            background-color: ${nafColor.information.errorLight};
            `;
    case NotificationType.WARNING:
      return `
            background-color: ${nafColor.information.warningLight};
            `;
    case NotificationType.NEUTRAL:
      return `
            background-color: ${nafColor.neutral.neutral1};
            `;
    case NotificationType.INFO:
    default:
      return `
            background-color: ${nafColor.information.informationLight};
            `;
  }
});
export const ContentContainer = styled.div.withConfig({
  displayName: "Styles__ContentContainer",
  componentId: "sc-92xbps-1"
})(["display:flex;margin-right:auto;justify-content:center;"]);
export const IconContainer = styled.div.withConfig({
  displayName: "Styles__IconContainer",
  componentId: "sc-92xbps-2"
})(["display:flex;align-items:center;margin-right:", ";"], spacing.space16);
export const TextContainer = styled.div.withConfig({
  displayName: "Styles__TextContainer",
  componentId: "sc-92xbps-3"
})(["display:flex;flex-direction:column;justify-content:center;"]);
export const StyledTitle = styled(Text).withConfig({
  displayName: "Styles__StyledTitle",
  componentId: "sc-92xbps-4"
})(["font-size:1rem;font-style:normal;font-weight:300;line-height:1.5rem;"]);
export const StyledActionLink = styled.a.withConfig({
  displayName: "Styles__StyledActionLink",
  componentId: "sc-92xbps-5"
})(["color:", ";text-decoration:underline;text-underline-offset:4px;cursor:pointer;font-weight:500;"], nafColor.signature.black);
export const ButtonContainer = styled.div.withConfig({
  displayName: "Styles__ButtonContainer",
  componentId: "sc-92xbps-6"
})(["display:flex;align-items:center;margin-left:40px;span{font-size:1rem;font-style:normal;font-weight:300;line-height:1.5rem;font-weight:500;}.actionButton{margin-top:4px;}"]);
export const StyledInfoIcon = styled(Info).withConfig({
  displayName: "Styles__StyledInfoIcon",
  componentId: "sc-92xbps-7"
})(["height:", ";width:", ";"], spacing.space24, spacing.space24);
export const StyledInfo = styled(StyledInfoIcon).withConfig({
  displayName: "Styles__StyledInfo",
  componentId: "sc-92xbps-8"
})(["color:", ";"], nafColor.information.information);
export const StyledError = styled(StyledInfoIcon).withConfig({
  displayName: "Styles__StyledError",
  componentId: "sc-92xbps-9"
})(["color:", ";"], nafColor.information.errorDark);
export const StyledWarning = styled(StyledInfoIcon).withConfig({
  displayName: "Styles__StyledWarning",
  componentId: "sc-92xbps-10"
})(["color:", ";"], nafColor.information.warning);
export const StyledAction = styled(StyledInfoIcon).withConfig({
  displayName: "Styles__StyledAction",
  componentId: "sc-92xbps-11"
})(["color:", ";"], nafColor.signature.black);
export const StyledNeutral = styled(StyledInfoIcon).withConfig({
  displayName: "Styles__StyledNeutral",
  componentId: "sc-92xbps-12"
})(["color:", ";"], nafColor.neutral.neutral5);
//# sourceMappingURL=Styles.js.map